import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  inject,
} from '@angular/core';
import { TranslationService } from './modules/i18n';
// language list
import enLang from './modules/i18n/vocabs/en.json';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import arLang from './modules/i18n/vocabs/ar.json';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LocalizationService } from './shared/services/localization.service';
import { LanguageRouteService } from './core/services/language_url.service';
import { AuthSyncService } from './core/services/async-auth.service';
import { GlobalShortcutService } from './core/services/global-shortcut.service';

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default, //TODO: check why they are using OnPush in the theme
})
export class AppComponent implements OnInit {
  private readonly globalShortcutService = inject(GlobalShortcutService);

  currentLang: any;
  direction: 'rtl.css' | 'ltr.css';
  currentLanguage = 'ar'; // Default language
  btnLangText = 'Ar';

  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private translate: TranslateService,
    private localization: LocalizationService,
    private languageListener: LanguageRouteService,
    @Inject(DOCUMENT) private document: Document,
    private authSyncService: AuthSyncService
  ) {
    // register translations
    this.translationService.loadTranslations(
      {
        "lang": "en",
        "data": enLang
      },
      {
        "lang": "ar",
        "data": arLang
      },
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );

    if (!sessionStorage.getItem('accessToken')) {
      this.authSyncService.requestSessionTokenFromOtherTabs();
    }
  }
  changeLanguage(lang: string) {
    this.translate.use(lang);
  }
  ngOnInit() {
    this.modeService.init();
    this.diableTitlesTooltip();
    if (sessionStorage.getItem('accessToken')) {
      this.globalShortcutService.ensureShortcutsLoaded();
    }
  }

  diableTitlesTooltip() {

  }

  loadStyle(lang: string) {
    if (this.btnLangText === 'Ar') {
      this.btnLangText = 'En';
      lang = 'ar'
    } else {
      this.btnLangText = 'Ar';
      lang = 'en'
    }
    const styleId = 'direction-style';
    this.localization.switchLanguage(lang);
    this.currentLang = this.localization.currentLanguage(lang);
    if (lang == 'ar') {
      this.localization.loadLocalizationStyle(styleId, './assets/css/style.rtl.css');
    } else {
      this.localization.loadLocalizationStyle(styleId, './styles.scss');
    }
    this.direction = this.currentLang.isRightToLeft ? 'rtl.css' : 'ltr.css';

    const html = this.document.getElementsByTagName('html')[0];
    html.dir = this.currentLang.isRightToLeft ? 'rtl' : 'ltr';

    const body = this.document.getElementsByTagName('body')[0];
    body.dir = this.currentLang.isRightToLeft ? 'rtl' : 'ltr';

    const head = this.document.getElementsByTagName('head')[0];
    let themeLink = this.document.getElementById(
      'client-theme'
    ) as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = this.direction;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${this.direction}`;
      head.appendChild(style);
    }
  }
}
